export default __webpack_public_path__ + "075573cbe39d003138b03e21b3a17228.png";